import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { currentValue } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
import { nameSegment } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/summarizeServicePredicate';
import { setCollectionQuantifier } from './collection-predicate';
export const isSingleNameCollection = (predicate)=>{
    if (predicate.name == null || currentValue(predicate.name).trim() === '') return false;
    if (predicate.services != null) return false;
    return predicate.or == null || predicate.or.length === 0;
};
export const pureOrNamePills = (predicate)=>{
    const arms = predicate.or;
    if (arms == null || arms.length === 0) return undefined;
    if (nameSegment(predicate.name) != null || predicate.services != null) return undefined;
    const pills = arms.flatMap((arm, armIndex)=>{
        const valueLabel = nameSegment(arm.name);
        return valueLabel != null ? [
            {
                armIndex,
                valueLabel
            }
        ] : [];
    });
    return pills.length > 0 ? pills : undefined;
};
export const removeOrArm = (collection, quantifier, predicate, armIndex)=>{
    var _predicate_or;
    const remainingArms = ((_predicate_or = predicate.or) !== null && _predicate_or !== void 0 ? _predicate_or : []).filter((_, index)=>index !== armIndex);
    const nextPredicate = remainingArms.length > 0 ? _object_spread_props(_object_spread({}, predicate), {
        or: remainingArms
    }) : undefined;
    return setCollectionQuantifier(collection, quantifier, nextPredicate);
};
